import React, { useState } from "react";
import { FaSave } from "react-icons/fa";
import { changePassword } from "../../api/auth";

const PasswordChange = ({ onNotification }) => {
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateField = (name, value) => {
    let error = "";

    if (name === "currentPassword") {
      if (!value.trim()) {
        error = "La contraseña actual es obligatoria";
      }
    }

    if (name === "newPassword") {
      if (!value.trim()) {
        error = "La nueva contraseña es obligatoria";
      } else if (value.length < 6) {
        error = "La contraseña debe tener al menos 6 caracteres";
      }
    }

    if (name === "confirmPassword") {
      if (!value.trim()) {
        error = "Debes confirmar tu nueva contraseña";
      } else if (value !== formData.newPassword) {
        error = "Las contraseñas no coinciden";
      }
    }

    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    if (!touched[name]) {
      setTouched({
        ...touched,
        [name]: true,
      });
    }

    const fieldError = validateField(name, value);
    setErrors({
      ...errors,
      [name]: fieldError,
    });
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    setTouched({
      ...touched,
      [name]: true,
    });

    const fieldError = validateField(name, value);
    setErrors({
      ...errors,
      [name]: fieldError,
    });
  };

  const validateAll = () => {
    const newErrors = {};
    const allTouched = {};

    Object.keys(formData).forEach((field) => {
      allTouched[field] = true;
      const error = validateField(field, formData[field]);
      if (error) {
        newErrors[field] = error;
      }
    });

    setTouched(allTouched);
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateAll();

    if (!isValid) {
      onNotification({
        show: true,
        type: "error",
        message: "Por favor completa correctamente todos los campos",
      });
      return;
    }

    try {
      setIsSubmitting(true);
      const passwordData = {
        current_password: formData.currentPassword,
        new_password: formData.newPassword,
      };

      await changePassword(passwordData);

      setFormData({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      setTouched({});

      onNotification({
        show: true,
        type: "success",
        message: "Tu contraseña ha sido actualizada correctamente",
      });
    } catch (error) {
      console.error("Error al cambiar la contraseña:", error);
      onNotification({
        show: true,
        type: "error",
        message: error.message || "Error al actualizar la contraseña",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="form__header">
        <h2>Cambiar Contraseña</h2>
        <p>Mantén segura tu cuenta con una contraseña fuerte</p>
      </div>

      <div className="form__group">
        <label htmlFor="currentPassword">Contraseña actual</label>
        <input
          type="password"
          id="currentPassword"
          name="currentPassword"
          value={formData.currentPassword}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Ingresa tu contraseña actual"
          className={
            touched.currentPassword && errors.currentPassword
              ? "input-error"
              : ""
          }
        />
        {touched.currentPassword && errors.currentPassword && (
          <div className="error-message">{errors.currentPassword}</div>
        )}
      </div>

      <div className="form__group">
        <label htmlFor="newPassword">Nueva contraseña</label>
        <input
          type="password"
          id="newPassword"
          name="newPassword"
          value={formData.newPassword}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Ingresa tu nueva contraseña"
          className={
            touched.newPassword && errors.newPassword ? "input-error" : ""
          }
        />
        {touched.newPassword && errors.newPassword && (
          <div className="error-message">{errors.newPassword}</div>
        )}
      </div>

      <div className="form__group">
        <label htmlFor="confirmPassword">Confirmar contraseña</label>
        <input
          type="password"
          id="confirmPassword"
          name="confirmPassword"
          value={formData.confirmPassword}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Confirma tu nueva contraseña"
          className={
            touched.confirmPassword && errors.confirmPassword
              ? "input-error"
              : ""
          }
        />
        {touched.confirmPassword && errors.confirmPassword && (
          <div className="error-message">{errors.confirmPassword}</div>
        )}
      </div>

      <div className="form__actions">
        <button
          type="button"
          onClick={handleSubmit}
          className="btn btn-primary btn-save-all"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Guardando..." : "Cambiar Contraseña"}
          {!isSubmitting && <FaSave className="btn-icon" />}
        </button>
      </div>
    </>
  );
};

export default PasswordChange;
